<template>
    <b-button
        variant="primary"
        @click.stop="download()"
        title="Realiza o download do modelo (template)"
    >
        <span><i class="fa fa-download"></i> Download Modelo</span>
    </b-button>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'

export default {
    props: {
        modelo: {
            type: Object,
            default: () => ({})
        },

        tipoDocumento: {
            type: String
        }
    },

    methods: {
        download() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadModelo(
                this.$route.params.convenioId,
                this.modelo.modeloId,
                this.tipoDocumento
            ).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.modelo.nomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
